import { Injectable } from "@angular/core";
import { VirkesorderStatus } from "~app/common/models/constants";

@Injectable({
    providedIn: "root"
})
export class ArbetsorderVirkesorderService {

    private readonly iconErrorClass = "table-cell-icon-error";
    private readonly iconSelectedClass = "table-cell-icon-selected";
    private readonly iconDirtyClass = "table-cell-icon-dirty";
    private readonly iconDefaultClass = "fas fa-fw fa-file details-icon";

    getIkonForViol3(hasTransmissionErrorViol3: boolean, skickadTillViol3: boolean, dirtyProduktion: boolean, dirtyTransport: boolean): string {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (hasTransmissionErrorViol3) {
            return this.iconErrorClass;
        } else if (skickadTillViol3 && (dirtyProduktion || dirtyTransport)) {
            return this.iconDirtyClass;
        } else if(skickadTillViol3 && !dirtyProduktion && !dirtyTransport) {
            return this.iconSelectedClass;
        } else {
            return this.iconDefaultClass;
        }
    }

    getIkonVirkesorderstatus(virkesorderStatus: string, voContractDirty: boolean, skickadTillViol: boolean): string {
        if (VirkesorderStatus.Felstatusar.some(status => status === virkesorderStatus)) {
            return this.iconErrorClass;
        } else if (virkesorderStatus === VirkesorderStatus.Aktiv || (virkesorderStatus === VirkesorderStatus.Ny && !voContractDirty)) {
            return this.iconSelectedClass;
        } else if (virkesorderStatus === VirkesorderStatus.Sand) {
            return null;
        } else if (skickadTillViol && voContractDirty) {
            return this.iconDirtyClass;
        } else {
            return this.iconDefaultClass;
        }
    }
}
